












import { Vue, Component, Prop } from 'vue-property-decorator';
import { AdminDTO } from '../../../src_server/entity/dto/AdminDTO';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { MessageDialog } from '../../utils/MessageDialog';
import { AdminService } from '../../biz/remote/AdminService';
@Component({
  components: {},
  filters: {
    formatDt(d: Date) {
      return dayjs(d).format(DT_FORMAT_JA);
    },
  },
})
export default class AdminRow extends Vue {
  @Prop()
  private row!: AdminDTO;

  @Prop()
  private index!: number;

  async detail() {
    this.$emit('detail', this.row);
  }

  async passwordChange() {
    const user_id = this.row.userAuth.user_id;
    if (!user_id) {
      await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', user_id);
      return;
    }
    const newPassword = MessageDialog.prompt('新しいパスワードを入力してください。');
    if (!newPassword) {
      await MessageDialog.alert('パスワードは変更しませんでした。');
      return;
    }

    const biz = new AdminService();
    const updateResult = await biz.changePassword(user_id, newPassword);
    if (updateResult.hasError) {
      await MessageDialog.alert(updateResult.errorDescription);
      return;
    }
    MessageDialog.alertModal(`パスワードを変更しました。`);
  }
}
